import { request } from '@/api/httpClient'
import { RequestType } from '@/enums'

export async function commonCurrencies() {
  return request({
    method: 'common/Currencies',
    requestType: RequestType.GET
  })
}

export async function commonOrganisationDetails() {
  return request({
    method: 'common/OrganisationDetails'
  })
}

export async function commonListDocuments(payload) {
  const response = await request({
    method: 'common/ListDocuments',
    payload
  })
  return response.documents
}

export async function commonProductSelectionGroups() {
  return request({
    method: 'common/ProductSelectionGroups',
    requestType: RequestType.GET
  })
}

export async function commonProductSelectionTypes() {
  return request({
    method: 'common/ProductSelectionTypes',
    requestType: RequestType.GET
  })
}

export async function commonCustomerStatuses() {
  return request({
    method: 'common/CustomerStatuses',
    requestType: RequestType.GET
  })
}

export async function commonListProcessingLevels() {
  return request({
    method: 'common/ListProcessingLevels'
  })
}

export async function commonGetDocumentCategories() {
  return request({
    method: 'common/GetDocumentCategories'
  })
}

export async function commonGetDocumentDetails(id) {
  return request({
    method: 'common/DocumentDetails',
    payload: {
      Id: Number(id)
    }
  })
}

export async function commonSystemCurrencies() {
  return request({
    method: 'common/SystemCurrencies',
    requestType: RequestType.GET
  })
}
